module.exports = __webpack_public_path__ + "media/mypage/images/icons/sp_keyword-adcb631ca589ca45de1d883c3e2ce79c.png";